import { request, requestPage } from '@/lib/apiClient';

/**
 * Each customer's website.
 *
 * The public calls need no organisation argument: the API reads it from the
 * subdomain the page is served on. The admin calls edit the signed-in admin's
 * own site, whichever subdomain they are on.
 */
export const siteApi = {
  /** Name and landing-page content. Every storefront page needs it. */
  site: () => request({ url: '/storefront/site' }),

  /** Category tiles and product rails, resolved against the live catalogue. */
  showcase: () => request({ url: '/storefront/site/showcase' }),

  subscribe: (email) =>
    request({ url: '/storefront/site/newsletter', method: 'POST', data: { email } }),

  /** Contact form. Emailed to the support inbox, not stored. */
  contact: (message) =>
    request({ url: '/storefront/site/contact', method: 'POST', data: message }),

  // Admin
  adminGet: () => request({ url: '/admin/site' }),
  adminSave: (content) => request({ url: '/admin/site', method: 'PUT', data: content }),
  adminReset: () => request({ url: '/admin/site/reset', method: 'POST' }),
  uploadImage: (file) => {
    const form = new FormData();
    form.append('file', file);
    return request({ url: '/admin/site/images', method: 'POST', data: form });
  },
  subscribers: ({ page = 1, limit = 20 } = {}) =>
    requestPage({ url: '/admin/site/subscribers', params: { page, limit, sort: '-created_at' } }),
};
